<template>
    <v-flex xs12 sm12>
      <v-card>
        <v-container grid-list-sm fluid>
          <v-layout row wrap>
            <v-flex
              xs4
              d-flex
            >
              <v-card height="120px" flat tile class="d-flex">
                <v-img
                  :src="srcFirst"
                  class="grey lighten-2"
                >
                </v-img>
              </v-card>
            </v-flex>
            <v-flex
              xs4
              d-flex
            >
              <v-card height="120px" flat tile class="d-flex">
                <v-img
                  :src="srcSecond"
                  class="grey lighten-2"
                >
                </v-img>
              </v-card>
            </v-flex>
            <v-flex
              xs4
              d-flex
            >
              <v-card height="120px" flat tile class="d-flex">
                  <v-img
                        :src="srcThird"
                        class="grey lighten-2"
                  >
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
</template>

<script>
  //import { mapState } from 'vuex'

  export default {
    props: {
        srcFirst: String,

        srcSecond: String,

        srcThird: String,
    },
  }
</script>
<style>
.img-turtle {
  object-fit: scale-down;
}
</style>

